import t from "srraf";
export default function (r, o) {
  return void 0 === o && (o = {}), function (e, n) {
    var a = !1,
        i = parseFloat(r.getAttribute("data-threshold") || o.threshold || 0);
    return t(function () {
      for (var t = [], o = arguments.length; o--;) {
        t[o] = arguments[o];
      }

      var d = t[0],
          h = d.y,
          l = d.vh,
          p = r.getBoundingClientRect(),
          u = p.top + h,
          f = i >= .5 ? i : i * l,
          v = u + p.height - f >= h && u + f <= h + l;
      v && !a ? (a = !0, e && e.apply(void 0, t)) : !v && a && (a = !1, n && n.apply(void 0, t));
    });
  };
}